<template>
	<!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="dialog.estatus"
    persistent
    :max-width="400"
  >
		<v-container fluid>
		  <v-row>
		  	<v-col cols="12" class="pa-0">
		  		<v-card class="mx-auto shadowCard" >
			    <v-card-title class="text-h6 font-weight-regular justify-space-between">
			      <span class="text-subtitle-1"> Agregar carpeta </span>
			    </v-card-title>
			    <v-card-text>
			      <v-text-field
			        label="Nombre de la carpeta"
			        filled
			        dense
			        v-model="carpeta"
			      ></v-text-field>
			    </v-card-text>
			    <v-card-actions>
			      <v-btn color="red" dark small rounded @click="cancelar()">Cancelar</v-btn>
			      <v-spacer></v-spacer>
			      <v-btn color="success" dark small rounded @click="agregarCarpeta()">Agregar</v-btn>
			    </v-card-actions>
			  </v-card>
		  	</v-col>
		  </v-row>

		  <!-- Dialog de carga -->
	    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
	    <carga                v-if="cargar" />
		</v-container>
	</v-dialog>
</template>
<script>
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta              from '@/components/alertas/Alerta.vue'
  import carga               from '@/components/alertas/carga.vue';

  import validarErrores  from '@/mixins/validarErrores'



	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

  	props:[
			'dialog',
			'carpetaSeleccionadas'
	  ],

    data: () => ({
    	// Datos del alumno inscrito
    	alumnoNuevo: false,
    	alumnos:[],
    	id_alumno: null,
    	grupoActual:null,
			grupoSiguiente:null,
			nuevoGrupo:false,

			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      carpeta:''
    }),

    methods: {
      agregarCarpeta () {
      	let nivel = 1
      	let idcarpeta = null

      	if( this.carpetaSeleccionadas.length ){
      		nivel      = this.carpetaSeleccionadas[ this.carpetaSeleccionadas.length - 1 ].nivel
      		idcarpeta = this.carpetaSeleccionadas[ this.carpetaSeleccionadas.length - 1 ].idcarpetas
      	}

      	const payload = {
      		carpeta: this.carpeta,
      		nivel,
      		idcarpeta
      	}

        this.$http.post('carpetas.agregar', payload ).then(response=>{
        	this.carpeta = ''
        	this.validarSuccess( 'Carpeta agregada correctamente ')
        	this.dialog.estatus = false
        	this.$emit( 'recargarCarpeta', response.body )
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      cancelar( ){
      	this.carpeta = ''
      	this.$emit("cancelar")
      }
    },
  }
</script>


